import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .375,
		y: .625,
		width: 22,
		height: 22,
		rx: 2,
		fill: "#141414"
	})
});
export default SvgRectangle;
